import {
  FontSize,
  FontFamily,
  TextTransformOptions,
} from '@powdr/constants';

const fonts = {
  [FontFamily.BASE_FONT]: {
    fontFamily: '"Lato Regular"',
    textTransform: TextTransformOptions.NO_TRANSFORM,
    defaultSize: FontSize.REG50,
    scaling: 1,
  },
  [FontFamily.PRIMARY_FONT]: {
    fontFamily: '"Libre Franklin Bold"',
    textTransform: TextTransformOptions.UPPERCASE,
    defaultSize: FontSize.LRG30,
    scaling: 1,
  },
  [FontFamily.SECONDARY_FONT]: {
    fontFamily: '"Lato Bold"',
    textTransform: TextTransformOptions.UPPERCASE,
    defaultSize: FontSize.REG50,
    scaling: 1,
  },
};

const fontOverrides = {};

export const fontTheme = {
  fonts,
  FontSize,
  fontOverrides,
};
